import ProviderWrapper from './Wrapper';

class VideoVimeo extends ProviderWrapper {
  init() {
    const {
      id, isBackground, fs,
    } = this.dataParams;
    this.renderVideoOnPage();
    this.player = this.connectVideoDefault();
    this.addPreviewImage(this.player);

    this.player.source = {
      type: 'video',
      sources: [
        {
          src: id,
          provider: 'vimeo',
        },
      ],
    };

    this.player.config.vimeo = {
      controls: isBackground ? 0 : fs,
      portrait: true,
      autopause: 0,
      resetOnEnd: 1,
    };

    this.player.elements.poster.style.display = 'none';
  }
}

export default VideoVimeo;
